import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import API from "../Service/Baseservice";
import Edit from "../../Assets/img/Edit.svg";
import Loading from "../../Loading/loading";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
const IntakeFormEdit = () => {
    const navigate = useNavigate();

    const [searchParams] = useSearchParams();
    const initialLanguage = Number(searchParams.get("lang")) || 1;
    const [languageId, setLanguageId] = useState(initialLanguage);

    const [data, setData] = useState(null);
    const [consentText, setConsentText] = useState("");
    const [showAddPopup, setShowAddPopup] = useState(false);
    const [popupType, setPopupType] = useState("");
    const [isEdit, setIsEdit] = useState(false);
    const [acknowledgement, setAcknowledgement] = useState(null);
    const [loading, setLoading] = useState(false);
    const [servicesList, setServicesList] = useState([]);
    const query = new URLSearchParams(useLocation().search);
    const list = Number(query.get("list")) || "";
    const [selectedService, setSelectedService] = useState(list);
    const [inputTypes, setInputTypes] = useState([]);
    const [options, setOptions] = useState([{ option: "", options_value: "Yes" }]);
    const [deletedOptions, setDeletedOptions] = useState([]);
    const [columnTypes, setColumnTypes] = useState([]);
    const [showSectionPopup, setShowSectionPopup] = useState(false);
    const [sectionForm, setSectionForm] = useState({
        sections_id: null,
        sections_titles: "",
        section_heading: ""
    });
    const [isSectionEdit, setIsSectionEdit] = useState(false);
    const [errors, setErrors] = useState({
        label: "",
        placeholder: "",
    });
    const [formData, setFormData] = useState({
        id: null,
        label: "",
        placeholder: "",
        input_type: "",
        label_mandatory: "",
        sections_input_column_id: "",
        sections_input_row: "",
        dependent_on: "",
        show_when_value: ""
    });
    const [allFields, setAllFields] = useState([]);

    const validateForm = () => {
        let valid = true;
        let newErrors = { label: "", placeholder: "", input_type: "", sections_input_column_id: "", sections_input_row: "" };

        if (!formData.label.trim()) {
            newErrors.label = "Label is required";
            valid = false;
        }

        if (!formData.input_type) {
            newErrors.input_type = "Input type is required";
            valid = false;
        }

        if (!formData.sections_input_column_id) {
            newErrors.sections_input_column_id = "Section input column is required";
            valid = false;
        }

        setErrors(newErrors);
        return valid;
    };

    useEffect(() => {
        if (selectedService) {
            fetchIntakeForm();
        }
    }, [languageId, selectedService]);

    const fetchIntakeForm = () => {
        setLoading(true);

        API.post("/AdminSectionsLabelList/condition", { language_id: languageId, listofservice_id: selectedService })
            .then((res) => {
                if (res.data?.success) {
                    setData(res.data.data);

                    const ack = res.data.data?.consent_acknowledgement?.[0] || null;
                    setAcknowledgement(ack);
                    setConsentText(ack?.description || "");

                    // Collect all fields for dependency dropdown
                    const allFieldsList = [];
                    res.data.data?.forEach(section => {
                        section.data?.forEach(field => {
                            allFieldsList.push({
                                id: field.sections_labels_id,
                                label: field.label,
                                section: section.sections_titles
                            });
                        });
                    });
                    setAllFields(allFieldsList);
                }
            })
            .catch((err) => console.error(err))
            .finally(() => setLoading(false));
    };

    const fetchColumnTypes = () => {
        API.post("sectionsInputColumnList/webCondition", {
            language_id: languageId
        })
            .then((res) => {
                if (res.data.success) {
                    setColumnTypes(res.data.data);
                }
            })
            .catch((err) => console.error("Column type error:", err));
    };

    useEffect(() => {
        fetchColumnTypes();
    }, [languageId]);

    const handleToggleStatus = (type, item) => {
        let apiUrl = "";
        let payload = {};
        const newStatus = item.status === "active" ? "inactive" : "active";

        switch (type) {
            case "section":
                apiUrl = "newconsultationform_status/update";
                payload = {
                    sections_labels_id: item.sections_labels_id,
                    status: newStatus,
                };
                break;
            default:
                return;
        }

        API.post(apiUrl, payload)
            .then(() => fetchIntakeForm())
            .catch((err) => console.error("Status update failed:", err));
    };

    const handleSave = () => {
        if (!validateForm()) return;
        setLoading(true);

        const selectedType = inputTypes.find(
            (type) => type.sections_input_type_id === Number(formData.input_type)
        );

        const needsOptions = selectedType
            ? ["checkbox", "radio", "drop", "case", "bouton", "dérouler", "table", "tableau"]
                .some((key) => selectedType.input_type.toLowerCase().includes(key))
            : false;

        let apiUrl = "";
        let payload = {};

        if (isEdit) {
            apiUrl = "newconsultationform_edit1/update";

            payload = {
                sections_labels_id: formData.id,
                sections_id: formData.section_id,
                language_id: languageId,
                label: formData.label,
                placeholder: formData.placeholder,
                label_mandatory: formData.label_mandatory || "No",
                sections_input_type_id: Number(formData.input_type),
                sections_input_column_id: formData.sections_input_column_id,
                sections_input_row: formData.sections_input_row || "",
                dependent_on: formData.dependent_on ? Number(formData.dependent_on) : null,
                show_when_value: formData.show_when_value || "",
                active: 1,
            };

            if (needsOptions) {
                payload.options = [
                    ...options.map((opt) => {
                        return {
                            sections_options_id: opt.sections_options_id,
                            option: opt.option,
                            options_value: opt.options_value || null,
                            active: 1,
                        };
                    }),
                    ...deletedOptions,
                ];
            }
        } else {
            apiUrl = "add_newconsultationform1/add";

            payload = {
                model: "add_newconsultationform",
                sections_id: formData.section_id,
                language_id: languageId,
                label: formData.label,
                placeholder: formData.placeholder,
                label_mandatory: formData.label_mandatory || "No",
                sections_input_type_id: Number(formData.input_type),
                sections_input_column_id: formData.sections_input_column_id,
                sections_input_row: formData.sections_input_row || "",
                dependent_on: formData.dependent_on ? Number(formData.dependent_on) : null,
                show_when_value: formData.show_when_value || "",
                createdBy: 1,
                updatedBy: 1,
            };

            if (needsOptions) {
                payload.options = options
                    .filter(opt => opt.option && opt.option.trim())
                    .map((opt) => ({
                        option: opt.option.trim(),
                        options_value: opt.options_value || null
                    }));
            }
        }

        API.post(apiUrl, payload)
            .then(() => {
                setShowAddPopup(false);
                setOptions([{ option: "", options_value: "Yes" }]);
                setDeletedOptions([]);
                fetchIntakeForm();
            })
            .catch((err) => console.error("Save failed:", err))
            .finally(() => setLoading(false));
    };

    const fetchServices = () => {
        API.post("listofservice_list/condition", { language_id: languageId })
            .then((res) => {
                const list = (res?.data?.data?.data || []).slice().sort((a, b) => Number(a.order_by) - Number(b.order_by));
                const active = list.filter((x) => x.active === 1 || x.active === "1");

                setServicesList(active);

                if (active.length > 0) {
                    setSelectedService(active[0].listofservice_id);
                }
            })
            .catch((err) => console.error("Service load error:", err));
    };

    useEffect(() => {
        setSelectedService("");
        fetchServices();
    }, [languageId]);

    useEffect(() => {
        if (servicesList.length > 0) {
            const exists = servicesList.some(
                (s) => s.listofservice_id === selectedService
            );

            if (!exists) {
                setSelectedService(servicesList[0].listofservice_id);
            }
        }
    }, [servicesList]);

    const fetchInputTypes = () => {
        API.post("/sectioninputtype_list/condition", {
            language_id: languageId
        })
            .then((res) => {
                const list = res?.data?.data?.data || [];
                const active = list.filter(
                    (x) => x.active === 1 || x.active === "1"
                );

                setInputTypes(active);
            })
            .catch((err) => console.error("Input type load error:", err));
    };

    useEffect(() => {
        fetchInputTypes();
    }, [languageId]);

    const handleSectionSave = () => {
        if (!sectionForm.sections_titles.trim()) return;

        setLoading(true);

        let apiUrl = "";
        let payload = {};

        if (isSectionEdit) {
            apiUrl = "section_edit/update";
            payload = {
                model: "section_edit",
                sections_id: sectionForm.sections_id,
                listofservice_id: selectedService,
                language_id: languageId,
                sections_titles: sectionForm.sections_titles,
                section_heading: sectionForm.section_heading,
                active: 1
            };
        } else {
            apiUrl = "add_section/add";
            payload = {
                listofservice_id: selectedService,
                language_id: languageId,
                sections_titles: sectionForm.sections_titles,
                section_heading: sectionForm.section_heading,
                createdBy: 1,
                updatedBy: 1
            };
        }

        API.post(apiUrl, payload)
            .then(() => {
                setShowSectionPopup(false);
                fetchIntakeForm();
            })
            .catch((err) => console.error("Section save failed:", err))
            .finally(() => setLoading(false));
    };

    // Get dependent field count for a given field
    const getDependentCount = (fieldId) => {
        let count = 0;
        data?.forEach(section => {
            section.data?.forEach(field => {
                if (field.dependent_on === fieldId) {
                    count++;
                }
            });
        });
        return count;
    };

    return (
        <div className="newss-containeradd">
            <div className="service-header-bar">
                <h2 className="services-title1">Intake Form</h2>

                <div className="button-group">
                    <button
                        className="add-btn"
                        style={{ marginTop: 24 }}
                        onClick={() => {
                            setIsSectionEdit(false);
                            setSectionForm({
                                sections_id: null,
                                sections_titles: "",
                                section_heading: ""
                            });
                            setShowSectionPopup(true);
                        }}
                    >
                        Add Section Label
                    </button>

                    {/* Dependent Children Questions Section */}
                    {/* <button
                        className="add-btn"
                        style={{ marginTop: 24, marginLeft: 10, backgroundColor: "#6c757d" }}
                        onClick={() => {
                            setPopupType("children");
                            setIsEdit(false);
                            setFormData({
                                id: null,
                                label: "Dependent Children",
                                placeholder: "",
                                input_type: inputTypes.find(t => t.input_type?.toLowerCase().includes("checkbox"))?.sections_input_type_id || "",
                                label_mandatory: "No",
                                section_id: data?.[0]?.sections_id || null,
                                sections_input_column_id: 1,
                                sections_input_row: "",
                                dependent_on: "",
                                show_when_value: ""
                            });
                            // Set options for children checkboxes
                            const childrenOptions = [
                                "Child 1 (Name & Age)",
                                "Child 2 (Name & Age)",
                                "Child 3 (Name & Age)",
                                "Child 4 (Name & Age)",
                                "Child 5 (Name & Age)"
                            ];
                            setOptions(childrenOptions);
                            setShowAddPopup(true);
                        }}
                    >
                        Add Dependent Children Questions
                    </button> */}

                    {/* Service Name */}
                    <div className="filter-block">
                        <label>Service Name</label>
                        <div className="input-container">
                            <select
                                className="input-field"
                                value={selectedService}
                                onChange={(e) => {
                                    setSelectedService(Number(e.target.value));
                                }}
                            >
                                {servicesList.map((cat) => (
                                    <option key={cat.listofservice_id} value={cat.listofservice_id}>
                                        {cat.heading}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <div className="filter-block">
                        <label>Language</label>
                        <div className="input-container">
                            <select
                                className="input-field"
                                value={languageId}
                                onChange={(e) =>
                                    setLanguageId(Number(e.target.value))
                                }
                            >
                                <option value={1}>English</option>
                                <option value={2}>Français</option>
                            </select>
                        </div>
                    </div>

                    <button
                        onClick={() => navigate("/Consultation")}
                        className="cancel-btn "
                        style={{ marginTop: 24 }}
                    >
                        Back
                    </button>
                </div>
            </div>

            {loading ? (
                <Loading />
            ) : (
                <>
                    <div className="consultation-container">
                        {data?.map((section) => (
                            <div className="intake-content" key={section.sections_id}>
                                {/* Section Header */}
                                <div className="intake-header1">
                                    <div className="section_header">
                                        <h5 className="intake-title1">
                                            {section.sections_titles}
                                        </h5>
                                        {!section.data?.some(
                                            (item) => item.input_type === "checkbox declaration"
                                        ) && (
                                                <img
                                                    src={Edit}
                                                    alt="Edit"
                                                    className="icon-btn1"
                                                    onClick={() => {
                                                        setIsSectionEdit(true);
                                                        setSectionForm({
                                                            sections_id: section.sections_id,
                                                            sections_titles: section.sections_titles,
                                                            section_heading: section.section_heading
                                                        });
                                                        setShowSectionPopup(true);
                                                    }}
                                                />
                                            )}
                                    </div>
                                    <div className="intake-buttons">
                                        <button
                                            className="add-btn"
                                            onClick={() => {
                                                setPopupType("section");
                                                setIsEdit(false);
                                                setFormData({
                                                    id: null,
                                                    label: "",
                                                    placeholder: "",
                                                    input_type: "",
                                                    label_mandatory: "No",
                                                    section_id: section.sections_id,
                                                    sections_input_column_id: "",
                                                    sections_input_row: "",
                                                    dependent_on: "",
                                                    show_when_value: ""
                                                });
                                                setOptions([{ option: "", options_value: "Yes" }]);
                                                setShowAddPopup(true);
                                            }}
                                        >
                                            Add Input
                                        </button>
                                    </div>
                                </div>

                                <h5
                                    className="intake-heading"
                                    dangerouslySetInnerHTML={{
                                        __html: section.section_heading || "",
                                    }}
                                />

                                {/* Section Fields */}
                                <div className="social-grid">
                                    {section.data.map((item) => {
                                        const dependentCount = getDependentCount(item.sections_labels_id);
                                        return (
                                            <div
                                                className="social-item"
                                                key={item.sections_labels_id}
                                                style={{ position: "relative" }}
                                            >
                                                <div className="wcu-status-container">
                                                    <img
                                                        src={Edit}
                                                        alt="Edit"
                                                        className="icon-btn1"
                                                        onClick={() => {
                                                            setIsEdit(true);
                                                            setPopupType("section");

                                                            const matchedType = inputTypes.find(
                                                                (type) =>
                                                                    type.sections_input_type_id === item.sections_input_type_id ||
                                                                    type.input_type === item.input_type
                                                            );

                                                            const normalize = (val) =>
                                                                val?.toLowerCase().replace("colonne", "column");

                                                            const matchedColumn = columnTypes.find(col =>
                                                                normalize(col.columns_value) === normalize(item.columns_value)
                                                            );

                                                            setFormData({
                                                                id: item.sections_labels_id,
                                                                label: item.label,
                                                                placeholder: item.placeholder || "",
                                                                input_type: matchedType ? matchedType.sections_input_type_id : "",
                                                                sections_input_column_id: matchedColumn
                                                                    ? matchedColumn.sections_input_column_id
                                                                    : "",
                                                                label_mandatory: item.label_mandatory || "No",
                                                                section_id: section.sections_id,
                                                                sections_input_row: item.sections_input_row || "",
                                                                dependent_on: item.dependent_on || "",
                                                                show_when_value: item.show_when_value || ""
                                                            });

                                                            if (item.options && item.options.length > 0) {
                                                                // IMPORTANT FIX: Preserve sections_options_id and options_value
                                                                setOptions(item.options.map(opt => ({
                                                                    sections_options_id: opt.sections_options_id,
                                                                    option: opt.option,
                                                                    options_value: opt.options_value || "Yes"
                                                                })));
                                                            } else {
                                                                setOptions([{ option: "", options_value: "Yes" }]);
                                                            }

                                                            setShowAddPopup(true);
                                                        }}
                                                    />

                                                    <label className="wcu-switch">
                                                        <input
                                                            type="checkbox"
                                                            checked={item.status === "active"}
                                                            onChange={() =>
                                                                handleToggleStatus("section", item)
                                                            }
                                                        />
                                                        <span className="wcu-slider round">
                                                            <span className="wcu-switch-label">
                                                                {item.status === "active" ? "ON" : "OFF"}
                                                            </span>
                                                        </span>
                                                    </label>
                                                </div>

                                                {dependentCount > 0 && (
                                                    <div style={{
                                                        marginBottom: "12px",
                                                        backgroundColor: "#ffc107",
                                                        color: "#000",
                                                        fontSize: "11px",
                                                        padding: "3px 10px",
                                                        borderRadius: "4px",
                                                        fontWeight: "bold",
                                                        display: "inline-block"
                                                    }}>
                                                        {dependentCount} dependent field(s)
                                                    </div>
                                                )}
                                                {/* {isDependentField && (
                                                    <div style={{
                                                        marginBottom: "8px",
                                                        padding: "4px 8px",
                                                        backgroundColor: "#e7f3ff",
                                                        borderRadius: "4px",
                                                        fontSize: "11px",
                                                        color: "#0066cc"
                                                    }}>
                                                        ⚡ Depends on: {allFields.find(f => f.id === item.dependent_on)?.label || item.dependent_on}
                                                        {item.show_when_value && ` = "${item.show_when_value}"`}
                                                    </div>
                                                )} */}

                                                <div className="social-inputs">
                                                    <div className="input-group1">
                                                        <label>
                                                            Label <span className="required">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            value={item.label}
                                                            readOnly
                                                        />
                                                    </div>

                                                    {item.placeholder && (
                                                        <div className="input-group1">
                                                            <label>Placeholder</label>
                                                            <input
                                                                type="text"
                                                                value={item.placeholder}
                                                                readOnly
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Add/Edit Popup */}
                    {showAddPopup && (
                        <div className="blogtag-popup-overlay" onClick={() => setShowAddPopup(false)}>
                            <div className="blogtag-popup-box edit-mode" onClick={(e) => e.stopPropagation()}>
                                <div className="popup-scroll-intakefrom">
                                    <h3>{isEdit ? "Edit Input" : "Add Input"}</h3>

                                    <div className="blogtag-admin-form-group">
                                        <label>
                                            Label <span className="required">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            value={formData.label}
                                            onChange={(e) => {
                                                setFormData({ ...formData, label: e.target.value });
                                                setErrors({ ...errors, label: "" });
                                            }}
                                        />
                                        {errors.label && <p className="error-text">{errors.label}</p>}
                                    </div>

                                    <div className="blogtag-admin-form-group">
                                        <label>Placeholder</label>
                                        <input
                                            type="text"
                                            value={formData.placeholder}
                                            onChange={(e) => {
                                                setFormData({ ...formData, placeholder: e.target.value });
                                                setErrors({ ...errors, placeholder: "" });
                                            }}
                                        />
                                        {errors.placeholder && (
                                            <p className="error-text">{errors.placeholder}</p>
                                        )}
                                    </div>

                                    <div className="blogtag-admin-form-group">
                                        <label>Input Type<span className="required">*</span></label>
                                        <select
                                            value={Number(formData.input_type) || ""}
                                            onChange={(e) =>
                                                setFormData({
                                                    ...formData,
                                                    input_type: Number(e.target.value)
                                                })
                                            }
                                        >
                                            <option value="">Select Type</option>
                                            {inputTypes.map((item) => (
                                                <option key={item.sections_input_type_id} value={item.sections_input_type_id}>
                                                    {item.input_type}
                                                </option>
                                            ))}
                                        </select>
                                        {errors.input_type && (
                                            <p className="error-text">{errors.input_type}</p>
                                        )}
                                    </div>

                                    <div className="blogtag-admin-form-group">
                                        <label>Input Column Type<span className="required">*</span></label>
                                        <div style={{ display: "flex", gap: "15px" }}>
                                            {columnTypes.map((col) => {
                                                const isSelected =
                                                    Number(formData.sections_input_column_id) ===
                                                    col.sections_input_column_id;

                                                return (
                                                    <button
                                                        key={col.sections_input_column_id}
                                                        type="button"
                                                        className={`btn ${isSelected ? "btn-primary" : "btn-outline-secondary"}`}
                                                        onClick={() =>
                                                            setFormData({
                                                                ...formData,
                                                                sections_input_column_id: col.sections_input_column_id
                                                            })
                                                        }
                                                    >
                                                        {["column-1", "colonne-1"].includes(col.columns_value) ? (
                                                            <i className="bi bi-square" style={{ fontSize: "20px" }}></i>
                                                        ) : (
                                                            <>
                                                                <i className="bi bi-square" style={{ fontSize: "20px", marginRight: "5px" }}></i>
                                                                <i className="bi bi-square" style={{ fontSize: "20px" }}></i>
                                                            </>
                                                        )}
                                                    </button>
                                                );
                                            })}
                                        </div>
                                        {errors.sections_input_column_id && (
                                            <p className="error-text">{errors.sections_input_column_id}</p>
                                        )}
                                    </div>

                                    {(() => {
                                        const selectedType = inputTypes.find(
                                            (type) =>
                                                type.sections_input_type_id === Number(formData.input_type)
                                        );

                                        const showRowType = selectedType
                                            ? ["table", "tableau"].includes(
                                                selectedType.input_type.toLowerCase()
                                            )
                                            : false;

                                        return showRowType;
                                    })() && (
                                            <div className="blogtag-admin-form-group">
                                                <label>Input Row Type</label>
                                                <input
                                                    type="text"
                                                    value={formData.sections_input_row || ""}
                                                    placeholder="e.g: 2"
                                                    onChange={(e) => {
                                                        setFormData({
                                                            ...formData,
                                                            sections_input_row: e.target.value
                                                        });
                                                        setErrors({
                                                            ...errors,
                                                            sections_input_row: ""
                                                        });
                                                    }}
                                                />
                                                {errors.sections_input_row && (
                                                    <p className="error-text">{errors.sections_input_row}</p>
                                                )}
                                            </div>
                                        )}

                                    {/* Dependency Field */}
                                    <div className="blogtag-admin-form-group">
                                        <label>Dependent On (Conditional Field)</label>
                                        <select
                                            value={formData.dependent_on || ""}
                                            onChange={(e) =>
                                                setFormData({
                                                    ...formData,
                                                    dependent_on: e.target.value,
                                                    show_when_value: ""
                                                })
                                            }
                                        >
                                            <option value="">No Dependency</option>
                                            {allFields.map((field) => (
                                                <option key={field.id} value={field.id}>
                                                    {field.label} ({field.section})
                                                </option>
                                            ))}
                                        </select>
                                        <small>This field will only show when the selected field has a specific value</small>
                                    </div>

                                    {/* Show When Value - only if dependent_on is set */}
                                    {formData.dependent_on && (
                                        <div className="blogtag-admin-form-group">
                                            <label>Show When Value Equals</label>
                                            <input
                                                type="text"
                                                value={formData.show_when_value || ""}
                                                onChange={(e) =>
                                                    setFormData({
                                                        ...formData,
                                                        show_when_value: e.target.value
                                                    })
                                                }
                                                placeholder="e.g., Yes, No, Other option value"
                                            />
                                            <small>Enter the exact value that triggers this field to appear</small>
                                        </div>
                                    )}

                                    {(() => {
                                        const selectedType = inputTypes.find(
                                            (type) => type.sections_input_type_id === Number(formData.input_type)
                                        );

                                        const needsOptions = selectedType
                                            ? ["checkbox", "radio", "drop", "case", "bouton", "dérouler", "table", "tableau"]
                                                .some((key) =>
                                                    selectedType.input_type.toLowerCase().includes(key)
                                                )
                                            : false;

                                        return needsOptions;
                                    })() && (
                                            <div className="blogtag-admin-form-group">
                                                <label>Options</label>
                                                <div style={{ marginBottom: "10px", fontSize: "12px", color: "#666" }}>
                                                    <span style={{ display: "inline-block", width: "60%" }}>Option Text</span>
                                                    <span style={{ display: "inline-block", width: "30%" }}>Options Value</span>
                                                    <span style={{ display: "inline-block", width: "10%" }}></span>
                                                </div>
                                                
                                                {options.map((opt, index) => (
                                                    <div key={index} style={{ display: "flex", gap: "10px", marginBottom: "8px", alignItems: "center" }}>
                                                        <input
                                                            type="text"
                                                            value={opt.option || ""}
                                                            placeholder={`Option ${index + 1}`}
                                                             disabled={!!opt.sections_options_id}
                                                            onChange={(e) => {
                                                                const updated = [...options];
                                                                updated[index] = { ...updated[index], option: e.target.value };
                                                                setOptions(updated);
                                                            }}
                                                            style={{ flex: 2, padding: "8px", borderRadius: "4px", border: "1px solid #ddd" }}
                                                        />

                                                        <select
                                                            value={opt.options_value || "Yes"}
                                                            onChange={(e) => {
                                                                const updated = [...options];
                                                                updated[index] = { ...updated[index], options_value: e.target.value };
                                                                setOptions(updated);
                                                            }}
                                                            style={{ flex: 1, padding: "8px", borderRadius: "4px", border: "1px solid #ddd" }}
                                                        >
                                                            <option value="Null">Null</option>
                                                            <option value="Yes">Yes</option>
                                                            <option value="No">No</option>
                                                        </select>

                                                        {options.length > 1 && (
                                                            <button
                                                                type="button"
                                                                onClick={() => {
                                                                    const removed = options[index];
                                                                    if (isEdit && removed && removed.sections_options_id) {
                                                                        setDeletedOptions(prev => {
                                                                            if (prev.some(item => item.sections_options_id === removed.sections_options_id)) return prev;
                                                                            return [...prev, { 
                                                                                sections_options_id: removed.sections_options_id, 
                                                                                option: removed.option, 
                                                                                options_value: removed.options_value,
                                                                                active: 0 
                                                                            }];
                                                                        });
                                                                    }
                                                                    setOptions(options.filter((_, i) => i !== index));
                                                                }}
                                                                style={{ padding: "8px 12px", cursor: "pointer", backgroundColor: "#dc3545", color: "white", border: "none", borderRadius: "4px" }}
                                                            >
                                                                ❌
                                                            </button>
                                                        )}
                                                    </div>
                                                ))}
                                                
                                                <button 
                                                    type="button" 
                                                    onClick={() => setOptions([...options, { option: "", options_value: "Yes" }])} 
                                                    style={{ marginTop: "8px", padding: "8px 16px", cursor: "pointer", backgroundColor: "#28a745", color: "white", border: "none", borderRadius: "4px" }}
                                                >
                                                    + Add Option
                                                </button>
                                                
                                                <small style={{ display: "block", marginTop: "8px", fontSize: "11px", color: "#666" }}>
                                                    Note: "Yes" means selecting this option will enable dependent fields. "No" means selecting this option will disable/hide dependent fields.
                                                </small>
                                            </div>
                                        )}

                                    <div className="blogtag-admin-form-group">
                                        <label>Label Mandatory</label>
                                        <select
                                            value={formData.label_mandatory || "No"}
                                            onChange={(e) =>
                                                setFormData({
                                                    ...formData,
                                                    label_mandatory: e.target.value
                                                })
                                            }
                                        >
                                            <option value="No">No</option>
                                            <option value="Yes">Yes</option>
                                        </select>
                                    </div>

                                    <div className="blogtag-popup-buttons">
                                        <button
                                            className="cancel-btn "
                                            onClick={() => {
                                                setShowAddPopup(false);
                                                setErrors({ label: "", placeholder: "" });
                                            }}
                                        >
                                            Back
                                        </button>
                                        <button className="btn saves-btn" onClick={handleSave}>
                                            Save
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Section Popup */}
                    {showSectionPopup && (
                        <div className="blogtag-popup-overlay" onClick={() => setShowSectionPopup(false)}>
                            <div
                                className="blogtag-popup-box"
                                onClick={(e) => e.stopPropagation()}
                            >
                                <h3>{isSectionEdit ? "Edit Section" : "Add Section"}</h3>

                                <div className="blogtag-admin-form-group">
                                    <label>Section Title</label>
                                    <input
                                        type="text"
                                        value={sectionForm.sections_titles}
                                        onChange={(e) =>
                                            setSectionForm({
                                                ...sectionForm,
                                                sections_titles: e.target.value
                                            })
                                        }
                                    />
                                </div>

                                <div className="blogtag-admin-form-group">
                                    <label>Section Heading</label>
                                    <CKEditor
                                        editor={ClassicEditor}
                                        data={sectionForm.section_heading || ""}
                                        onChange={(event, editor) => {
                                            const html = editor.getData();
                                            setSectionForm({
                                                ...sectionForm,
                                                section_heading: html
                                            });
                                        }}
                                        config={{
                                            toolbar: [
                                                "undo", "redo", "|",
                                                "heading", "|",
                                                "bold", "italic", "underline", "|",
                                                "bulletedList", "numberedList",
                                            ],
                                        }}
                                    />
                                </div>
                                <div className="blogtag-popup-buttons">
                                    <button
                                        className="cancel-btn"
                                        onClick={() => setShowSectionPopup(false)}
                                    >
                                        Cancel
                                    </button>
                                    <button className="btn saves-btn" onClick={handleSectionSave}>
                                        Save
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default IntakeFormEdit;